"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../../Resource"));
const corporateAccounting_1 = require("../../../utils/corporateAccounting");
const EPatrimoineRevenusCorporationGroups_1 = require("../../../enums/Scpi/Corporation/Groups/EPatrimoineRevenusCorporationGroups");
const options = { groups: [EPatrimoineRevenusCorporationGroups_1.EPatrimoineRevenusCorporationGroups.corporateAccounting] };
class CorporateAccountingRequestResource extends Resource_1.default {
}
exports.default = CorporateAccountingRequestResource;
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2Q1a", answers), options),
    (0, class_validator_1.IsBoolean)(options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2Q1a", void 0);
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2Q2a", answers), options),
    (0, class_validator_1.IsBoolean)(options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2Q2a", void 0);
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2Q2b", answers), options),
    (0, class_validator_1.IsBoolean)(options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2Q2b", void 0);
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2Q2c", answers), options),
    (0, class_validator_1.IsBoolean)(options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2Q2c", void 0);
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2Q2d", answers), options),
    (0, class_validator_1.IsBoolean)(options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2Q2d", void 0);
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2Q2e", answers), options),
    (0, class_validator_1.IsBoolean)(options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2Q2e", void 0);
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2Q2f", answers), options),
    (0, class_validator_1.IsBoolean)(options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2Q2f", void 0);
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2Q3a", answers), options),
    (0, class_validator_1.IsBoolean)(options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2Q3a", void 0);
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2Q3b", answers), options),
    (0, class_validator_1.IsBoolean)(options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2Q3b", void 0);
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2AccountingStandards", answers), options),
    (0, class_validator_1.IsString)(options),
    (0, class_validator_1.Matches)(/\S/u, options),
    (0, class_validator_1.MaxLength)(300, options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2AccountingStandards", void 0);
__decorate([
    (0, class_transformer_1.Expose)(options),
    (0, class_validator_1.ValidateIf)((answers) => (0, corporateAccounting_1.isCorporateAccountingFieldActive)("hexaPillar2ExclusionBasis", answers), options),
    (0, class_validator_1.IsString)(options),
    (0, class_validator_1.Matches)(/\S/u, options),
    (0, class_validator_1.MaxLength)(300, options),
    __metadata("design:type", Object)
], CorporateAccountingRequestResource.prototype, "hexaPillar2ExclusionBasis", void 0);
